// SWIPER SLIDER
import Swiper from 'swiper/bundle';
// import Swiper styles
import 'swiper/css/bundle';

/* swiper */
const swipers = document.querySelectorAll('[data-swiper]');

if (swipers) {
  swipers.forEach(function (element) {
    const settings = JSON.parse(element.dataset.swiper);
    var swiper = new Swiper(element, settings);
  });
}

// GSAP VERTICAL SLIDER
import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

//console.clear();
const contentContainer = document.querySelector('.content-container');

if (contentContainer) {
  // Set up our scroll trigger
  const ST = ScrollTrigger.create({
    trigger: ".content-container",
    start: "top 120px",
    end: "bottom 65%",
    //markers: true,
    onUpdate: getCurrentSection,
  });


  const contentMarkers = gsap.utils.toArray(".text-content");
  const verticalContainer = document.getElementById("verSlider");
  
  // Set up our content behaviors
  contentMarkers.forEach(marker => {
    marker.content = document.querySelector('#'+marker.dataset.markercontent);
    // enter functions
    marker.content.enter = function() {
      // on first load remove class - no double animation
      if (marker.content.classList.contains('firstload')) {
        marker.content.classList.remove('firstload');
        gsap.fromTo(marker.content, {autoAlpha: 1}, {duration: 0, autoAlpha: 1});
      } else {
        gsap.fromTo(marker.content, {autoAlpha: 0}, {duration: 0.2, autoAlpha: 1});
      }
    }
    // leave function
    marker.content.leave = function() {
      gsap.to(marker.content, {duration: 0.1, autoAlpha: 0});
    }
    
  });
  
  // Handle the updated position
  let lastContent;
  function getCurrentSection() {
    let newContent;
    let currOff;
    let half_height = window.innerHeight/4;
  
    const currScroll = scrollY;
    const containerOffTop = verticalContainer.offsetTop-half_height; // - 70, Position Container + halbe Höhe Window (center)
  
    // Find the current section
    contentMarkers.forEach(marker => {
      // container + offset marker in container - margin container
      currOff = containerOffTop+marker.offsetTop;
      //if(currScroll > marker.offsetTop) {
      if(currScroll > currOff) {
        newContent = marker.content;
      }
    });
    
    // If the current section is different than that last, animate in
    if(newContent && (lastContent == null || !newContent.isSameNode(lastContent))) {
      // Fade out last section
      if(lastContent) {
        lastContent.leave();
      }
      
      // Animate in new section
      newContent.enter();
      
      lastContent = newContent;
    }
  }
  
  // desktop only
  const media = window.matchMedia("screen and (max-width: 991px)");
  ScrollTrigger.addEventListener("refreshInit", checkSTState);
  checkSTState();
  
  function checkSTState() {
    if(media.matches) {
      ST.disable();
    } else {
      ST.enable();
    }
  }

}